import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card } from 'material-ui/Card';
import { crudCreate as crudCreateAction } from '../../admin-on-rest/src/actions/dataActions';
import withPermissionsFilteredChildren from '../../admin-on-rest/src/auth/withPermissionsFilteredChildren';

import {connect} from "react-redux";
import compose from 'recompose/compose';

class CreateGiftCard extends Component {
    getBasePath() {
        const { location } = this.props;
        return location.pathname
            .split('/')
            .slice(0, -1)
            .join('/');
    }

    defaultRedirectRoute() {
        const { hasShow, hasEdit } = this.props;
        if (hasEdit) return 'edit';
        if (hasShow) return 'show';
        return 'list';
    }

    save = (record, redirect) => {
        this.props.crudCreate(
            this.props.resource,
            record,
            this.getBasePath(),
            redirect
        );
    };

    render() {
        const {
            children,
            isLoading,
            resource,
        } = this.props;

        if (!children) return null;
        const basePath = this.getBasePath();
        
        const cardStyle = {
            opacity: isLoading ? 0.8 : 1,
            backgroundColor: "transparent",
            boxShadow: "none"
        }

        return (
            <div className="create-page">
                <Card style={cardStyle}>
                
                    {React.cloneElement(children, {
                        save: this.save,
                        resource,
                        basePath,
                        record: {},
                        redirect:
                            typeof children.props.redirect === 'undefined'
                                ? this.defaultRedirectRoute()
                                : children.props.redirect,
                    })}
                </Card>
            </div>
        );
    }
}

CreateGiftCard.propTypes = {
    actions: PropTypes.element,
    children: PropTypes.element,
    crudCreate: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    resource: PropTypes.string.isRequired,
    title: PropTypes.any,
    hasList: PropTypes.bool,
};

CreateGiftCard.defaultProps = {
    data: {},
};

function mapStateToProps(state) {
    return {
        isLoading: state.admin.loading > 0,
    };
}

const enhance = compose(
    connect(mapStateToProps, 
        { crudCreate: crudCreateAction }
    ),
    withPermissionsFilteredChildren
);

export default enhance(CreateGiftCard);



// WEBPACK FOOTER //
// ./src/components/CRM/CreateGiftCard.js